var module = angular.module('octopusApp.infrastructure');

// Courtesy of https://github.com/chesleybrown/autofill-directive (MIT)

module.directive('autofill', function() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      scope.$on('autofill-submit', function(e) {
        ngModel.$setViewValue(element.val());
      });
    }
  };
});

module.directive('autofillSubmit', ['$parse', function($parse) {
  return {
    link: function (scope, element) {
      var fn = $parse(element.attr('autofill-submit'));
      element.on('submit', function(event) {
        scope.$broadcast('autofill-submit');
        scope.$apply(function() {
          fn(scope, {$event:event});
        });
      });
    }
  };
}]);




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/autofill.js
// module id = 136029151116023
// module chunks = 1